import React, { useContext, useEffect, useState } from 'react';
import CardContainer from '@components/redesign/CardContainer';
import KpiGrid from '@components/redesign/KpiGrid';
import KpiTile from '@components/redesign/KpiTile';
import { useDynamicGraphQLQuery } from '../../../hooks/useDynamicGraphQLQuery';
import { FilterContext } from '../../../components/FilterBar/FilterProvider';
import {
  getDefaultMetrics,
  processMetrics,
  getMetricDefinitions,
} from './metricsRegistry';
import { constants } from 'constants/Constants';
interface SummaryMetricsProps {
  title?: string;
  showInfoIcon?: boolean;
}

const SummaryMetrics: React.FC<SummaryMetricsProps> = ({
  title = 'Summary',
  showInfoIcon = true,
}) => {
  const { selectedProduct, selectedMarket, selectedPlant, rgmPromoUserType } =
    useContext(FilterContext);
  const [overViewConfig, setOverviewConfig] = useState([]);

  const { data, isLoading } = useDynamicGraphQLQuery(
    'getUserAdoptionScorecard',
    {
      siteId: selectedPlant?.id,
      users:
        rgmPromoUserType?.value || constants?.rgmUserAdoptionFilters[2]?.value,
      customerId: null,
    },
    true,
    'StandardMetrics/UserAdoption'
  );
  useEffect(() => {
    if (data) {
      // Get default metrics for the selected product
      const productId = selectedProduct?.productId;
      const metricIds = getDefaultMetrics(productId);

      // Process the metrics with the common data and product
      const processedKPIs = processMetrics(metricIds, data, selectedProduct);
      setOverviewConfig(processedKPIs);
    }
  }, [data, selectedProduct, selectedPlant]);

  const dataDefinitions = {
    sections: [
      {
        sectionName: 'Scorecard',
        sectionKpiList: getMetricDefinitions(
          selectedProduct?.productId,
          selectedMarket?.marketId
        ),
      },
    ],
  };

  return (
    <CardContainer
      data-testid="summary-metrics"
      isLoading={isLoading}
      title={title}
      showInfoIcon={showInfoIcon}
      dataDefinitions={dataDefinitions}
      isAccordion={false}
    >
      <KpiGrid
        columnsDesktop={overViewConfig.length || 3}
        columnsTablet={overViewConfig.length || 3}
        columnsMobile={1}
      >
        {overViewConfig.map((item, index) => (
          <KpiTile key={index} data={item} />
        ))}
      </KpiGrid>
    </CardContainer>
  );
};

export default SummaryMetrics;
